import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSingleColumn = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 48 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 42,
			rx: 1,
			fill: "#F1F1F1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 5,
			width: 36,
			height: 9,
			rx: 1,
			fill: "#DBD9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 17,
			width: 26,
			height: 4,
			rx: 1,
			fill: "#DBD9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 24,
			width: 36,
			height: 6,
			rx: 1,
			fill: "#DBD9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 33,
			width: 36,
			height: 6,
			rx: 1,
			fill: "#DBD9D9"
		})
	]
});
export default SvgIconSingleColumn;
